// extracted by mini-css-extract-plugin
export default {"contactInfo":"AddressContacts_contactInfo__yyFEq","contactLink":"AddressContacts_contactLink__cyQYd","contact":"AddressContacts_contact__OYcYk"};